import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import axios from "axios";

const LoginPage = () => {
  //   const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        "/auth/signin",
        {
          username,
          password,
        }
      );

      if (response.status === 200) {
        const token = response.data;
        localStorage.setItem("token", token);
        window.location.href = "/";
      } else {
        throw Error(response.data);
      }
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Typography variant="h4" marginBottom={3}>
          Athena Admin Login
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          label="User Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          onClick={handleLogin}
          sx={{ marginTop: 2 }}
        >
          Log In
        </Button>
      </Box>
    </Container>
  );
};

export default LoginPage;
